/* Repair the accessible names of third-party widgets without changing their purchase logic. */
(() => {
  let nextId = 0;
  const repair = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const elements = (selector) => [
      ...(root instanceof Element && root.matches(selector) ? [root] : []),
      ...root.querySelectorAll(selector)
    ];
    elements('input.sss-selling-plan-radio').forEach(input => {
      const scope = input.closest('.purchase-option-details') || input.parentElement;
      const label = [...scope.querySelectorAll('label')].find(label => label.htmlFor === input.value || label.htmlFor === input.id);
      if (!label || !label.textContent.trim()) return;
      if (!input.id) input.id = `kama-purchase-option-${++nextId}`;
      label.htmlFor = input.id;
    });
    elements('.R-LabelTag[aria-label]').forEach(badge => badge.setAttribute('role', 'img'));
  };
  repair(document);
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) repair(node);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
